// extracted by mini-css-extract-plugin
export var askAiIcon = "_k1-9";
export var container = "_k1-0";
export var groupSeparator = "_k1-a";
export var highlight = "_k1-4";
export var resultIcon = "_k1-5";
export var resultItem = "_k1-7";
export var resultSubtitle = "_k1-3";
export var resultTitle = "_k1-2";
export var resultsList = "_k1-1";
export var searchGroup = "_k1-6";
export var selected = "_k1-8";